module.exports = __webpack_public_path__ + "img/mobile/General/spelser@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/General/spelser@1x.png
// module id = 190
// module chunks = 0